import { useState, useEffect, useRef, Fragment } from "react";
import "../../styles/website/Home.css";
import Layout from "../website/component/Layout.jsx";
import { getLatestStores } from "../../api/shopsApi.js";
import { submitHomeConsultation } from "../../api/consultation.js";
import ProOnlineToast from "./component/ProOnlineToast.jsx";

// اگر از Vite/CRA استفاده می‌کنی این دو فایل رو داخل src/assets قرار بده،
// در غیر این صورت مسیرها رو با ساختار پروژه‌ی خودت جایگزین کن.
import flowerTop from "../../assets/website/flower-header.svg";
import flowerRoadmap from "../../assets/website/flower-body.svg";
import axios from "axios";
import { API_BASE_URL } from "../../api/http.js";

// مسیر صفحه‌ی جستجوی محصولات (ProductsSearch) — با روت واقعی پروژه عوض کن
const PRODUCTS_SEARCH_PATH = "/searchproduct";

// مسیر صفحه‌ی اتاق پرو (دکمه شناور)
const FITTING_ROOM_PATH = "/fittingroom";

/* =========================================================
   آیکون‌های تکرارشونده (به جای SVG تکراری در چند بخش)
   ========================================================= */

const ClockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M12 7V12L15.5 14"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronLeftIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path
      d="M15 6L9 12L15 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SearchIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M20 20L16.2 16.2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const PinIcon = ({ size = 13 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 21C12 21 19 14.5 19 9.5C19 5.36 15.64 2 12 2C8.36 2 5 5.36 5 9.5C5 14.5 12 21 12 21Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="9.5" r="2.3" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const StarIcon = ({ filled = true }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill={filled ? "currentColor" : "none"}
  >
    <path
      d="M12 3.5L14.7 9.2L21 10.1L16.5 14.4L17.6 20.7L12 17.7L6.4 20.7L7.5 14.4L3 10.1L9.3 9.2L12 3.5Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </svg>
);

const QuoteMarkIcon = () => (
  <svg width="30" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M9.983 3v7.391c0 5.704-3.731 9.57-8.983 10.609l-.995-2.151c2.432-.917 3.995-3.638 3.995-5.849h-4v-10h9.983zm14.017 0v7.391c0 5.704-3.748 9.571-9 10.609l-.996-2.151c2.433-.917 3.996-3.638 3.996-5.849h-4v-10h10z" />
  </svg>
);

// آیکون‌های خطی برای آواتار نظرات (به‌جای ایموجی)
const PhoneAvatarIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="7"
      y="2"
      width="10"
      height="20"
      rx="2.2"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M10.7 18.3H13.3"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const HangerAvatarIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3.2C12 3.2 10.5 3.6 10.5 5C10.5 6 11.3 6.6 12 6.6C12.7 6.6 13.1 6.9 13.1 7.4C13.1 7.9 12.6 8.1 12 8.1"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12 8.1L21 14.3C21.9 14.9 21.5 16.3 20.4 16.4H3.6C2.5 16.3 2.1 14.9 3 14.3L12 8.1Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 19.5H19.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const BagAvatarIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 8H17.5L18.3 20.5C18.35 21.15 17.85 21.7 17.2 21.7H6.8C6.15 21.7 5.65 21.15 5.7 20.5L6.5 8Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9 8V6C9 4.3 10.3 3 12 3C13.7 3 15 4.3 15 6V8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const SparkleAvatarIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.5L13.9 9.3L21 11L13.9 12.7L12 19.5L10.1 12.7L3 11L10.1 9.3L12 2.5Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
  </svg>
);

const PawAvatarIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7.2" cy="9.5" r="1.8" stroke="currentColor" strokeWidth="1.4" />
    <circle cx="12" cy="6.5" r="1.8" stroke="currentColor" strokeWidth="1.4" />
    <circle
      cx="16.8"
      cy="9.5"
      r="1.8"
      stroke="currentColor"
      strokeWidth="1.4"
    />
    <path
      d="M12 11.8C9 11.8 6.8 13.7 6.8 16.1C6.8 18.4 9.1 19.5 12 19.5C14.9 19.5 17.2 18.4 17.2 16.1C17.2 13.7 15 11.8 12 11.8Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
  </svg>
);

// آیکون‌های دسته‌بندی فروشگاه (برای shop-avatar روی کارت فروشگاه)
const FoodAvatarIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 3V10C4 11.7 5.3 13 7 13C8.7 13 10 11.7 10 10V3"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 13V21"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M17 3C15 3 14 5 14 8C14 10 15 11 16 11.5V21"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BeautyAvatarIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 3H15L14 7H10L9 3Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M10 7V13.5C10 14 9.7 14.5 9.3 14.9L7 17.2C6.3 17.9 6.8 19 7.8 19H16.2C17.2 19 17.7 17.9 17 17.2L14.7 14.9C14.3 14.5 14 14 14 13.5V7"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

const ElectronicsAvatarIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3"
      y="4"
      width="18"
      height="12"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M8 20H16M12 16V20"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const HomeAvatarIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 11L12 4L21 11"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 10V19C5 19.6 5.4 20 6 20H18C18.6 20 19 19.6 19 19V10"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

const BookAvatarIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 5C4 4 5 3.5 6.5 3.5H11V19H6.5C5 19 4 19.5 4 20.5V5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M20 5C20 4 19 3.5 17.5 3.5H13V19H17.5C19 19 20 19.5 20 20.5V5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

const JewelryAvatarIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 3H18L22 9L12 21L2 9L6 3Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M2 9H22M9 3L12 9L8 9L12 21M15 3L12 9L16 9L12 21"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </svg>
);

// آیکون فروشگاه/خانه — هم در «چرا الان»، هم در قدم دوم نقشه‌راه و هم fallback آواتار کارت فروشگاه
const StoreIcon = ({ size = 48 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 10V20H20V10"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 10L5 4H19L21 10"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 10C3 11.7 4.3 13 6 13C7.7 13 9 11.7 9 10C9 11.7 10.3 13 12 13C13.7 13 15 11.7 15 10C15 11.7 16.3 13 18 13C19.7 13 21 11.7 21 10"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <path
      d="M9 20V16H15V20"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
  </svg>
);

// آیکون رفرش — برای دکمه‌ی فرم مشاوره رایگان
const RefreshIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 11A8 8 0 1 0 18.5 15.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M20 5V11H14"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// آیکون چوب‌لباسی — دکمه شناور اتاق پرو
const FittingHangerIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 8V7.2C12 6.5 12.6 6 13.3 5.8C14.4 5.5 15 4.6 15 3.8C15 2.8 14.1 2 13 2C11.9 2 11 2.8 11 3.8"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8L21.2 14.6C22.2 15.3 21.7 16.9 20.5 16.9H3.5C2.3 16.9 1.8 15.3 2.8 14.6L12 8Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
    <path
      d="M5 20.2H19"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </svg>
);

/* =========================================================
   نگاشت دسته‌بندی فروشگاه به آیکون
   ========================================================= */

const CATEGORY_ICON_MAP = [
  { keywords: ["پوشاک", "مد", "لباس", "مزون"], Icon: HangerAvatarIcon },
  {
    keywords: ["الکترونیک", "موبایل", "دیجیتال", "کامپیوتر"],
    Icon: ElectronicsAvatarIcon,
  },
  { keywords: ["آرایشی", "بهداشتی", "زیبایی"], Icon: BeautyAvatarIcon },
  { keywords: ["رستوران", "کافه", "غذا", "خوراکی"], Icon: FoodAvatarIcon },
  { keywords: ["خانه", "آشپزخانه", "دکوراسیون"], Icon: HomeAvatarIcon },
  { keywords: ["کیف", "کفش", "اکسسوری"], Icon: BagAvatarIcon },
  { keywords: ["کتاب", "لوازم تحریر"], Icon: BookAvatarIcon },
  { keywords: ["طلا", "جواهر", "زیورآلات"], Icon: JewelryAvatarIcon },
  { keywords: ["حیوان", "پت", "دام"], Icon: PawAvatarIcon },
];

function getShopIcon(category = "") {
  const match = CATEGORY_ICON_MAP.find(({ keywords }) =>
    keywords.some((kw) => category.includes(kw)),
  );
  const Icon = match ? match.Icon : StoreIcon;
  return <Icon size={26} />;
}

/* =========================================================
   داده‌ها
   ========================================================= */

const WHY_NOW = [
  {
    icon: <StoreIcon />,
    title: "فروشگاه اختصاصی خودت رو داشته باش",
    text: "محصولات، قیمت‌ها، سفارش‌ها و اطلاعات مشتری‌ها؛ همه در یک فضای اختصاصی برای کسب‌وکار تو.",
  },
  {
    icon: (
      <svg
        width="48"
        height="48"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 18L3.8 20.5C3.43 20.68 3 20.41 3 20V5.5C3 5.2 3.17 4.92 3.45 4.78L9 2L15 4.5L20.55 1.72C20.92 1.54 21.35 1.81 21.35 2.22V16.8C21.35 17.1 21.18 17.38 20.9 17.52L15 20.5L9 18Z"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
        <path d="M9 2V18" stroke="currentColor" strokeWidth="1.7" />
        <path d="M15 4.5V20.5" stroke="currentColor" strokeWidth="1.7" />
        <path
          d="M6 11H6.01M18 10H18.01"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
      </svg>
    ),
    title: "از هر جای ایران مشتری بگیر",
    text: "فروشگاه آنلاین تو محدود به یک محله یا شهر نیست. مشتری‌ها می‌تونن از سراسر ایران به محصولاتت دسترسی داشته باشن.",
  },
  {
    icon: (
      <svg
        width="48"
        height="48"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 3L20 6V11.5C20 16.4 16.7 20.5 12 22C7.3 20.5 4 16.4 4 11.5V6L12 3Z"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 12L10.5 14.5L16 9"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: "مالک مسیر فروش خودت باش",
    text: "شبکه‌های اجتماعی فقط یک کانال جذب مشتری هستن؛ فروشگاه آنلاین، خانه‌ی اصلی کسب‌وکار توئه.",
  },
];

const ROADMAP_STEPS = [
  {
    title: "ثبت‌نام رایگان",
    time: "۳۰ ثانیه",
    text: "با شماره موبایل ثبت‌نام کن. بدون هیچ هزینه‌ای.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="7"
          y="2"
          width="10"
          height="20"
          rx="2.2"
          stroke="currentColor"
          strokeWidth="1.7"
        />
        <path
          d="M10.7 18.3H13.3"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    title: "ثبت درخواست فروشگاه",
    time: "۱ دقیقه",
    text: "درخواست راه‌اندازی فروشگاهت رو ثبت کن؛ تیم ما ظرف چند ساعت تأیید می‌کنه.",
    icon: <StoreIcon />,
  },
  {
    title: "وارد کردن اطلاعات",
    time: "۱ دقیقه",
    text: "نام، آدرس، تصاویر و روش‌های پرداخت فروشگاهت رو تنظیم کن.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4 20L4.8 16.6C4.9 16.2 5.1 15.8 5.4 15.5L15.5 5.4C16.3 4.6 17.6 4.6 18.4 5.4L18.6 5.6C19.4 6.4 19.4 7.7 18.6 8.5L8.5 18.6C8.2 18.9 7.8 19.1 7.4 19.2L4 20Z"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
        <path d="M13.5 7.5L16.5 10.5" stroke="currentColor" strokeWidth="1.7" />
      </svg>
    ),
  },
  {
    title: "اضافه کردن محصولات",
    time: "۳۰ ثانیه",
    text: "محصولاتت رو با عکس، توضیحات و قیمت اضافه کن.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3 8L12 3L21 8V16L12 21L3 16V8Z"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
        <path
          d="M3 8L12 13L21 8"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
        <path d="M12 13V21" stroke="currentColor" strokeWidth="1.7" />
      </svg>
    ),
  },
  {
    title: "شروع فروش سراسری",
    time: "همین الان",
    text: "فروشگاهت آماده‌ست! از تهران تا دورافتاده‌ترین شهرها مشتری داری.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 15C12 15 8 13 8 8C8 4 12 2 12 2C12 2 16 4 16 8C16 13 12 15 12 15Z"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
        <circle
          cx="12"
          cy="8"
          r="1.6"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M8 13C8 13 5.5 14 5 17C5 17 8 16.5 9 15"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
        <path
          d="M16 13C16 13 18.5 14 19 17C19 17 16 16.5 15 15"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
        <path
          d="M10 15L9 20L12 18L15 20L14 15"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

const EARN_STEPS = [
  { number: "۱", title: "ثبت‌نام رایگان" },
  { number: "۲", title: "ساخت فروشگاه برای دیگران" },
  { number: "۳", title: "دریافت پورسانت ماهانه" },
];

const FEATURED_TESTIMONIAL = {
  rating: 5,
  text: "وقتی اینستاگرامم فیلتر شد، فکر می‌کردم کسب‌وکارم تموم شد. اما با این پلتفرم نه‌تنها جبران کردم، بلکه فروشم ۳ برابر شد. الان دیگه نگران قطعی اینترنت نیستم.",
  name: "علی احمدی",
  role: "مدیر فروشگاه الکترونیک — تهران",
  avatar: <PhoneAvatarIcon size={20} />,
};

const TESTI_TRUST = {
  average: "۴.۹",
  count: "۲٬۰۰۰+ نظر ثبت‌شده",
  avatars: [
    <PhoneAvatarIcon key="phone" size={16} />,
    <HangerAvatarIcon key="hanger" size={16} />,
    <BagAvatarIcon key="bag" size={16} />,
    <SparkleAvatarIcon key="sparkle" size={16} />,
    <PawAvatarIcon key="paw" size={16} />,
  ],
};

const TESTIMONIALS = [
  {
    rating: 5,
    text: "راه‌اندازی فروشگاهم کمتر از یک ساعت طول کشید. همون هفته‌ی اول اولین سفارشم از یه شهر دیگه اومد.",
    name: "سارا محمدی",
    role: "مزون رویا — یزد",
    avatar: <HangerAvatarIcon size={16} />,
  },
  {
    rating: 5,
    text: "برام مهم بود مالک واقعی فروشگاهم باشم، نه یه پیج که هر لحظه ممکنه از دست بره.",
    name: "رضا کریمی",
    role: "دیجی‌مارکت — یزد",
    avatar: <BagAvatarIcon size={16} />,
  },
  {
    rating: 4,
    text: "بخش معرفی به دوستان برام یه منبع درآمد جدید شده؛ ماهانه پورسانت می‌گیرم.",
    name: "نگار حسینی",
    role: "آنشرلی بیوتی — یزد",
    avatar: <SparkleAvatarIcon size={16} />,
  },
];

const BUSINESS_TYPES = [
  "فروشگاه فیزیکی",
  "تولیدکننده",
  "خدمات",
  "رستوران و کافه",
  "سایر",
];
const PROVINCES = ["تهران", "یزد", "اصفهان", "مشهد", "شیراز", "سایر استان‌ها"];

/* =========================================================
   ساب‌کامپوننت‌ها
   ========================================================= */

// نوار جستجوی محصولات همه‌ی فروشگاه‌ها — با ارسال، کاربر به صفحه‌ی جستجوی محصولات می‌ره
function ProductSearchBar() {
  const [query, setQuery] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    const q = query.trim();
    window.location.href = q
      ? `${PRODUCTS_SEARCH_PATH}?q=${encodeURIComponent(q)}`
      : PRODUCTS_SEARCH_PATH;
  }

  return (
    <form className="psearch tile reveal" onSubmit={handleSubmit}>
      <div className="psearch-text">
        <h2>تو محصولات همه‌ی فروشگاه‌ها جستجو کن</h2>
        <p>
          اسم محصول رو بنویس تا بین هزاران محصول فروشگاه‌های ایران پیداش کنیم.
        </p>
      </div>
      <div className="psearch-box">
        <span className="psearch-icon">
          <SearchIcon />
        </span>
        <input
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="مثلاً: مانتو، هدفون، رژ لب..."
          aria-label="جستجوی محصولات"
        />
        <button type="submit" className="psearch-btn">
          <SearchIcon />
          <span>جستجو</span>
        </button>
      </div>
    </form>
  );
}

function WhyTile({ icon, title, text }) {
  return (
    <div className="tile-dark why-tile reveal">
      <div className="why-icon">{icon}</div>
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
}

function RoadmapStep({ step, index }) {
  const isEven = index % 2 === 1;
  return (
    <div className={`roadmap-step ${isEven ? "step-even" : "step-odd"}`}>
      {!isEven && <StepCard step={step} />}
      <div className="step-node">{step.icon}</div>
      {isEven && <StepCard step={step} />}
    </div>
  );
}

function StepCard({ step }) {
  return (
    <div className="step-card tile">
      <div className="step-card-up">
        <h4>{step.title}</h4>
        <span className="step-time">
          <ClockIcon />
          {step.time}
        </span>
      </div>
      <p>{step.text}</p>
    </div>
  );
}

function ShopCard({ shop }) {
  return (
    <div className="tile shop-tile">
      <div className="shop-cover">
        {shop.image ? (
          <img src={shop.image} loading="lazy" alt={shop.name} />
        ) : (
          <div className="shop-cover-fallback">
            {getShopIcon(shop.category)}
          </div>
        )}
        <span className="shop-status">
          <span className="dot"></span> فعال
        </span>
      </div>
      <div className="shop-avatar">{getShopIcon(shop.category)}</div>
      <div className="shop-content">
        <div className="shop-body">
          <span className="shop-cat">{shop.category}</span>
          <h4>{shop.name}</h4>
          <span className="shop-loc">
            <PinIcon />
            {shop.location}
          </span>
        </div>
        <a href={shop.url} className="shop-link">
          ورود به فروشگاه
          <ChevronLeftIcon />
        </a>
      </div>
    </div>
  );
}

function ShopCardSkeleton() {
  return <div className="tile shop-tile shop-skeleton" />;
}

function TrustStrip({ trust }) {
  return (
    <div className="testi-trust">
      <div className="testi-trust-avatars">
        {trust.avatars.map((a, i) => (
          <span key={i} className="testi-trust-avatar">
            {a}
          </span>
        ))}
      </div>
      <div className="testi-trust-info">
        <span className="testi-trust-num">
          {trust.average}
          <span className="testi-stars testi-stars-sm">
            {Array.from({ length: 5 }).map((_, i) => (
              <StarIcon key={i} filled />
            ))}
          </span>
        </span>
        <span className="testi-trust-count">{trust.count}</span>
      </div>
    </div>
  );
}

function FeaturedTestimonial({ item }) {
  return (
    <div className="testi-featured reveal">
      <span className="testi-featured-quote">
        <QuoteMarkIcon />
      </span>
      <span className="testi-stars">
        {Array.from({ length: 5 }).map((_, i) => (
          <StarIcon key={i} filled={i < item.rating} />
        ))}
      </span>
      <p className="testi-featured-text">{item.text}</p>
      <div className="testi-person">
        <span className="testi-avatar">{item.avatar}</span>
        <div className="testi-person-info">
          <h4>{item.name}</h4>
          <span>{item.role}</span>
        </div>
      </div>
    </div>
  );
}

function TestimonialRow({ item }) {
  return (
    <div className="testi-row reveal">
      <span className="testi-avatar testi-avatar-sm">{item.avatar}</span>
      <div className="testi-row-body">
        <div className="testi-row-top">
          <h4>{item.name}</h4>
          <span className="testi-stars testi-stars-sm">
            {Array.from({ length: 5 }).map((_, i) => (
              <StarIcon key={i} filled={i < item.rating} />
            ))}
          </span>
        </div>
        <span className="testi-row-role">{item.role}</span>
        <p className="testi-row-text">{item.text}</p>
      </div>
    </div>
  );
}

function EarnStep({ number, title }) {
  return (
    <div className="tile-dark earn-step reveal">
      <div className="why-icon">
        <span className="earn-num-icon">{number}</span>
      </div>
      <h4>{title}</h4>
    </div>
  );
}

// فرم «مشاوره رایگان» — با کپچای جمع ساده (اعتبارسنجی سمت کلاینت) و ارسال واقعی به بک‌اند
function ConsultForm() {
  const [captcha, setCaptcha] = useState(() => {
    const a = Math.floor(Math.random() * 8) + 2;
    const b = Math.floor(Math.random() * 8) + 2;
    return { a, b };
  });
  const [answer, setAnswer] = useState("");
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  function refreshCaptcha() {
    const a = Math.floor(Math.random() * 8) + 2;
    const b = Math.floor(Math.random() * 8) + 2;
    setCaptcha({ a, b });
    setAnswer("");
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    const form = e.target;
    const fullName = form.name.value.trim();
    const mobile = form.phone.value.trim();
    const businessType = form.businessType.value;
    const province = form.province.value;

    if (!fullName || !mobile) {
      setError("لطفاً نام و شماره موبایل رو وارد کن.");
      return;
    }
    if (!businessType || !province) {
      setError("لطفاً نوع کسب‌وکار و استان رو انتخاب کن.");
      return;
    }
    if (!/^09\d{9}$/.test(mobile)) {
      setError("شماره موبایل معتبر نیست (مثال: 09123456789).");
      return;
    }
    if (Number(answer) !== captcha.a + captcha.b) {
      setError("پاسخ سؤال امنیتی درست نیست.");
      refreshCaptcha();
      return;
    }

    setLoading(true);
    try {
      await submitHomeConsultation({
        full_name: fullName,
        mobile,
        business_type: businessType,
        province,
      });
      setSubmitted(true);
    } catch (err) {
      setError("ارسال درخواست با خطا مواجه شد. لطفاً دوباره تلاش کن.");
      refreshCaptcha();
    } finally {
      setLoading(false);
    }
  }

  if (submitted) {
    return (
      <p className="consult-success">
        درخواستت ثبت شد! کارشناس ما ظرف ۲ ساعت باهات تماس می‌گیره.
      </p>
    );
  }

  return (
    <form className="consult-form" onSubmit={handleSubmit}>
      <div className="consult-row">
        <input
          name="name"
          placeholder="نام و نام خانوادگی"
          disabled={loading}
        />
        <input
          name="phone"
          placeholder="شماره موبایل"
          inputMode="tel"
          disabled={loading}
        />
      </div>
      <div className="consult-row">
        <select name="businessType" defaultValue="" disabled={loading}>
          <option value="" disabled>
            نوع کسب‌وکار
          </option>
          {BUSINESS_TYPES.map((t) => (
            <option key={t}>{t}</option>
          ))}
        </select>
        <select name="province" defaultValue="" disabled={loading}>
          <option value="" disabled>
            استان
          </option>
          {PROVINCES.map((p) => (
            <option key={p}>{p}</option>
          ))}
        </select>
      </div>
      <div className="consult-row consult-captcha-row">
        <label className="consult-captcha-label" htmlFor="captcha-answer">
          {captcha.a} + {captcha.b} = ؟
        </label>
        <input
          id="captcha-answer"
          name="captcha"
          type="text"
          inputMode="numeric"
          placeholder="پاسخ"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          disabled={loading}
        />
      </div>
      {error && <span className="consult-error">{error}</span>}
      <button
        type="submit"
        className="btn btn-primary btn-lg consult-submit"
        disabled={loading}
      >
        <RefreshIcon /> {loading ? "در حال ارسال..." : "درخواست مشاوره رایگان"}
      </button>
    </form>
  );
}

/* =========================================================
   کامپوننت اصلی
   ========================================================= */

export default function Home() {
  const trackRef = useRef(null);
  const progressRef = useRef(null);
  const markerRef = useRef(null);

  const [shops, setShops] = useState([]);
  const [shopsLoading, setShopsLoading] = useState(true);
  const [shopsError, setShopsError] = useState(false);

  useEffect(() => {
    const registerVisit = async () => {
      try {
        await axios.post(`${API_BASE_URL}/api/core-basics/visits/`);
      } catch (error) {
        console.error("Failed to register visit", error);
      }
    };

    registerVisit();
  }, []);
  // دریافت جدیدترین فروشگاه‌ها از بک‌اند
  useEffect(() => {
    let cancelled = false;

    async function fetchShops() {
      try {
        setShopsLoading(true);
        const res = await getLatestStores();
        if (cancelled) return;

        const list = Array.isArray(res.data)
          ? res.data
          : res.data?.results || [];

        const mapped = list.map((s) => ({
          id: s.store_id,
          name: s.store_name,
          category: s.store_type_title,
          location: `${s.city_name}، ${s.province_name}`,
          image: s.store_image,
          url: s.store_url,
        }));

        setShops(mapped);
        setShopsError(false);
      } catch (err) {
        if (!cancelled) setShopsError(true);
      } finally {
        if (!cancelled) setShopsLoading(false);
      }
    }

    fetchShops();
    return () => {
      cancelled = true;
    };
  }, []);

  // اسکرول نوار پیشرفت نقشه‌راه + انیمیشن ورود عناصر هنگام دیده‌شدن
  useEffect(() => {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    function updateRoad() {
      const track = trackRef.current;
      if (!track) return;
      const rect = track.getBoundingClientRect();
      const vh = window.innerHeight;
      const start = vh * 0.82;
      const total = rect.height + vh * 0.55;
      let pct = (start - rect.top) / total;
      pct = Math.max(0, Math.min(1, pct));
      if (progressRef.current)
        progressRef.current.style.height = `${pct * 100}%`;
      if (markerRef.current) markerRef.current.style.top = `${pct * 100}%`;
    }

    let ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateRoad();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    updateRoad();

    const revealTargets = document.querySelectorAll(
      ".roadmap-step, .shop-tile, .reveal",
    );

    let observer;
    if ("IntersectionObserver" in window && !reduceMotion) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) entry.target.classList.add("in-view");
          });
        },
        { threshold: 0.22 },
      );
      revealTargets.forEach((el) => observer.observe(el));
    } else {
      revealTargets.forEach((el) => el.classList.add("in-view"));
    }

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (observer) observer.disconnect();
    };
  }, [shops]);

  return (
    <Layout>
      <img className="image-flower-top" src={flowerTop} alt="" />

      {/* ---------- Hero ---------- */}
      <section className="hero">
        <div className="wrap hero-grid">
          <div>
            <span className="eyebrow">
              <span className="dot"></span> بانک جامع فروشگاه ایران
            </span>
            <h1>فروشگاهت رو بساز، مشتری‌هات رو پیدا کن</h1>
            <p className="hero-sub">
              فروشگاه آنلاین خودت رو در چند دقیقه راه‌اندازی کن و محصولاتت رو در
              معرض دید مشتریان سراسر ایران قرار بده.
            </p>
            <div className="hero-actions">
              <a href="/panel/login" className="btn btn-primary btn-lg">
                همین الان شروع کن
              </a>
              <a href="/shops" className="btn btn-ghost btn-lg">
                نمونه فروشگاه‌ها
              </a>
            </div>
            <div className="trust-chips">
              <span className="chip tile">پارک علم و فناوری یزد</span>
              <span className="chip tile">پرداخت امن</span>
              <span className="chip tile">پشتیبانی ۲۴ ساعته</span>
            </div>
          </div>

          <div className="hero-visual">
            <ProOnlineToast />
            <div className="float-chip float-chip-1">
              📦 محصول جدید اضافه شد
            </div>
            <div className="float-chip float-chip-2">💳 پرداخت موفق</div>
            <div className="float-chip float-chip-3">💰 +۴۵M تومان/ماه</div>

            <div className="stack-card stack-card-1">
              <div className="card-top">
                <div className="card-avatar">🌸</div>
                <span className="card-live">
                  <span className="dot"></span> فعال
                </span>
              </div>
              <h4>مزون رویا</h4>
              <p>پوشاک و مد — یزد</p>
              <div className="card-stat-row">
                <div className="card-stat">
                  <b>۱۲۴</b>بازدید امروز
                </div>
                <div className="card-stat">
                  <b>۱۸</b>سفارش
                </div>
                <div className="card-stat">
                  <b>۹۸٪</b>رضایت
                </div>
              </div>
            </div>

            <div className="stack-card stack-card-2">
              <div className="card-top">
                <div className="card-avatar">💄</div>
                <span className="card-live">
                  <span className="dot"></span> فعال
                </span>
              </div>
              <h4>آنشرلی بیوتی</h4>
              <p>آرایشی و بهداشتی</p>
            </div>

            <div className="stack-card stack-card-3">
              <div className="card-top">
                <div className="card-avatar">📱</div>
              </div>
              <h4>دیجی‌مارکت یزد</h4>
              <p>الکترونیک</p>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- Product search (جایگزین بخش آمار) ---------- */}
      <section className="stats">
        <div className="wrap">
          <ProductSearchBar />
        </div>
      </section>

      {/* ---------- Why now ---------- */}
      <section className="why-now">
        <div className="wrap">
          <div className="section-head">
            <div>
              <h2>وابستگی به شبکه‌های اجتماعی یعنی ریسک کسب و کار</h2>
              <p>
                با قطعی اینترنت، فروشگاه‌های مستقل بدون مشکل به کارشون ادامه
                می‌دن.
              </p>
            </div>
          </div>
          <div className="why-grid">
            {WHY_NOW.map((tile) => (
              <WhyTile key={tile.title} {...tile} />
            ))}
          </div>
        </div>
      </section>

      {/* ---------- Roadmap ---------- */}
      <section className="roadmap">
        <div className="wrap">
          <div className="section-head">
            <div>
              <h2>از صفر تا صد فروش، فقط در ۵ قدم</h2>
              <p>
                مسیری که هر فروشنده‌ای، بدون دانش فنی، می‌تونه توی چند دقیقه طی
                کنه.
              </p>
            </div>
          </div>

          <div className="roadmap-track" ref={trackRef}>
            <div className="road-line-wrap">
              <div className="road-progress" ref={progressRef}></div>
            </div>
            <div className="road-marker" ref={markerRef}>
              <ClockIcon />
            </div>

            <div className="roadmap-steps">
              {ROADMAP_STEPS.map((step, i) => (
                <RoadmapStep key={step.title} step={step} index={i} />
              ))}
            </div>

            <img className="image-flower-roadmap" src={flowerRoadmap} alt="" />
          </div>
        </div>
      </section>

      {/* ---------- Shops ---------- */}
      <section className="shops">
        <div className="wrap">
          <div className="section-head">
            <div>
              <h2>جدیدترین فروشگاه‌ها</h2>
              <p>
                فروشگاه‌هایی که همین اخیراً راه‌اندازی شدن و دارن رشد می‌کنن
              </p>
            </div>
            <a href="/shops" className="btn btn-ghost btn-sm">
              مشاهده همه
            </a>
          </div>

          {shopsLoading && (
            <div className="shops-grid">
              {Array.from({ length: 4 }).map((_, i) => (
                <ShopCardSkeleton key={i} />
              ))}
            </div>
          )}

          {!shopsLoading && shopsError && (
            <p className="shops-empty">
              خطا در دریافت فروشگاه‌ها. لطفاً بعداً دوباره امتحان کن.
            </p>
          )}

          {!shopsLoading && !shopsError && shops.length === 0 && (
            <p className="shops-empty">هنوز فروشگاهی ثبت نشده.</p>
          )}

          {!shopsLoading && !shopsError && shops.length > 0 && (
            <div className="shops-grid">
              {shops.map((shop) => (
                <ShopCard key={shop.id} shop={shop} />
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ---------- Testimonials ---------- */}
      <section className="testimonials">
        <div className="wrap">
          <div className="section-head testi-head">
            <div>
              <h2>افرادی که دکانا را انتخاب کردند</h2>
            </div>
          </div>
          <TrustStrip trust={TESTI_TRUST} />
          <div className="testi-layout">
            <FeaturedTestimonial item={FEATURED_TESTIMONIAL} />
            <div className="testi-list">
              {TESTIMONIALS.map((item, i) => (
                <TestimonialRow key={`${item.name}-${i}`} item={item} />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ---------- Earn / referral ---------- */}
      <section className="earn">
        <div className="wrap">
          <div className="section-head">
            <div>
              <h2>برای دوستات فروشگاه بساز، درآمد بگیر</h2>
              <p>
                هر کسب‌وکاری که می‌شناسی می‌تونی براشون فروشگاه آنلاین بسازی و
                ماهانه پورسانت بگیری. مشتری بگیر، فروشگاه بساز، تحویلش بده و
                پشتیبانیش با ما!
              </p>
            </div>
          </div>

          <div className="earn-stepper">
            {EARN_STEPS.map((step, i) => (
              <Fragment key={step.title}>
                <EarnStep number={step.number} title={step.title} />
                {i < EARN_STEPS.length - 1 && (
                  <div className="earn-step-arrow">
                    <ChevronLeftIcon />
                  </div>
                )}
              </Fragment>
            ))}
          </div>

          <div className="earn-highlight tile">
            <div className="earn-highlight-left">
              <span className="earn-highlight-num">
                <span className="earn-highlight-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="9"
                      stroke="currentColor"
                      strokeWidth="1.7"
                    />
                    <path
                      d="M9.3 14C9.3 15.1 10.5 16 12 16C13.5 16 14.7 15.1 14.7 14C14.7 12.9 13.5 12.4 12 12C10.5 11.6 9.3 11.1 9.3 10C9.3 8.9 10.5 8 12 8C13.5 8 14.7 8.9 14.7 10"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M12 6.5V8M12 16V17.5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
                تا ۴۵ میلیون تومان
              </span>
              <span className="earn-highlight-label">
                درآمد ماهانه از معرفی
              </span>
              <span className="earn-highlight-note">
                بر اساس میانگین پورسانت معرف‌های فعال دکانا در سه ماه اخیر
              </span>
            </div>
            <a
              href="/earn"
              className="btn btn-ghost btn-sm"
              target="_blank"
              rel="noopener noreferrer"
            >
              اطلاعات بیشتر
            </a>
          </div>
        </div>
      </section>

      {/* ---------- Consult / free consultation ---------- */}
      <section className="consult">
        <div className="wrap">
          <div className="section-head consult-head">
            <div>
              <h2>سوال داری؟ باهات تماس می‌گیریم</h2>
              <p>اطلاعاتت رو بذار، کارشناس ما ظرف ۲ ساعت زنگ می‌زنه</p>
            </div>
          </div>
          <div className="consult-card tile">
            <ConsultForm />
          </div>
        </div>
      </section>

      {/* ---------- دکمه شناور اتاق پرو ---------- */}
      <a
        href={FITTING_ROOM_PATH}
        className="fitting-fab"
        aria-label="ورود به اتاق پرو"
      >
        <span className="fitting-fab-icon">
          <FittingHangerIcon />
        </span>
        <span className="fitting-fab-label">اتاق پرو</span>
      </a>
    </Layout>
  );
}
